export const posConsultationProps = {
  basename: "/plataforma/consultas/pos",
};
